import { augmentedWrap } from './utils';

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  augmentedWrap(content)
    .updateStyle(
      'config',
      { theme: `${selectedVariant}.backdrop` },
      preserveOverrides
    )
    .value();
